<template>
  <button
    v-if="!loading"
    :class="$style.successButton"
    :disabled="disabled"
    @click="handleButtonClick"
    data-xpath="success-button"
    data-testid="success-button"
  >
    {{ title }}
  </button>
  <div
    :class="$style.successButton__loader"
    v-else
    data-xpath="success-button-loader"
    data-testid="success-button-loader"
  >
    <!-- Vue 3 compatible spinner -->
    <div
      class="spinner-border text-light"
      role="status"
      data-testid="spinner"
    >
      <span
        class="visually-hidden"
        data-testid="loading-text"
      >Loading...</span>
    </div>
  </div>
</template>

<script setup>
import { defineProps, defineEmits } from 'vue';

// Define props
const props = defineProps({
	title: {
		type: String,
		default: 'Button',
	},
	click: {
		type: Function,
		default: () => {},
	},
	clickDisabled: {
		type: Function,
		default: () => {},
	},
	disabled: {
		type: Boolean,
		default: false,
	},
	loading: {
		type: Boolean,
		default: false,
	},
});

// Define emits
const emit = defineEmits(['click', 'clickDisabled']);

// Methods
function handleButtonClick() {
	emit(props.disabled ? 'clickDisabled' : 'click');
}
</script>

<style lang="scss" module>
@import '../../styles/variables.scss';

.successButton {
    padding: 6px;
    border: 1px solid $green;
    border-radius: 2px;
    background-color: $green;
    outline: none !important;

    color: white;
    font-family: SourceSansPro, serif;
    font-size: 14px;

    &:disabled {
        opacity: 0.65;
        cursor: not-allowed;
    }

    &:hover {
        font-weight: 600;
        background-color: #32e891;
    }

    &:active {
        background-color: $sp-color-green-active;
    }

    &__loader {
        display: flex;
        justify-content: center;
        background-color: $green;
        padding: 6px;
        border-radius: 2px;

        & > div {
            width: 1.3rem;
            height: 1.3rem;
            border-width: 0.15em;
        }

        /* Ensure span inside spinner is properly styled */
        & > div > span {
            width: auto;
            height: auto;
        }
    }
}
</style>
